
import Vue from 'vue'
import InfoSquare from '../info-square/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'InfoSquareList',
  components: { InfoSquare },
  mixins: [staticBlockMixin],
  props: {
    isContentReverse: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
